<template>
  <v-app :key="id" :class="{ 'hide-scroll': drawerCar }">

   <v-app-bar
   flat
      app
      clipped-right
      light
      :height="92"
      id="borde"
      style="border-bottom: 5px solid #fff; background-color: #fff"
    >
      <v-card class="mx-auto" flat v-if="$vuetify.breakpoint.smAndDown">
          <v-img
            class="mx-auto"
            contain
            @click="
              toTopGo();
              CLR_BUSCAREPUESTO();
              $router.push({ path: `/` });
            "
            :src="`${domoapi2_img}Cia/15/logo?archivo=5.jpg`"
            id="Home"
            width="150"
          ></v-img>
          <v-toolbar dense class="elevation-0" width="100vw">
            <v-text-field
            hide-details
            clear-icon="mdi-close-circle"
            append-icon="mdi-magnify"
            class="rounded-xl"
            type="text"
            :label="`Buscar en DOMODECO`"
            background-color="#EEEEEE"
            clearable
            dense
            outlined
            color="primary"
            single-line
            v-model.trim="txtArticulo"
            @input="txtArticulo = txtArticulo.toUpperCase()"
            @click:append="idBuscar(txtArticulo)"
            @keyup.enter="idBuscar(txtArticulo)"
            required
            :loading="loading_buscar ? '#D3BC8D' : null"
            :error="ErrorBuscar"
            @click:clear="set_ErrorBuscar(false)"
            @keyup.esc="
              !loading_buscar
                ? (set_ErrorBuscar(false),
                  set_BuscarOverlay(false),
                  (txtArticulo = ''))
                : null
            "
          ></v-text-field>
          <v-btn
            icon
            @click.stop="
          set_ErrorBuscar(false);
          setDrawerMovil(true);
          menuresumen = false;
          txtArticulo = '';
        "
          >
            <v-icon x-large>mdi-menu</v-icon>
          </v-btn>
          </v-toolbar>
      <!--   <v-text-field
          class="rounded-xl mt-2"
          hide-details
          v-model.trim="txtArticulo"
          :label="`Buscar...`"
          type="text"
          background-color="#EEEEEE"
          clearable
          clear-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          @input="txtArticulo = txtArticulo.toUpperCase()"
          @click:append="idBuscar(txtArticulo)"
          @keyup.enter="idBuscar(txtArticulo)"
          required
          :loading="loading_buscar ? '#D3BC8D' : null"
          :error="ErrorBuscar"
          @click:clear="set_ErrorBuscar(false)"
          @keyup.esc="
            !loading_buscar
              ? (set_ErrorBuscar(false),
                set_BuscarOverlay(false),
                (txtArticulo = ''))
              : null
          "
          dense
          outlined
          color="primary"
          single-line
        >
        </v-text-field> -->
      </v-card>
      <v-container
        :class="['mx-auto']"
        style="max-width: 1340px"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col
            :cols="$vuetify.breakpoint.smAndDown ? 5 : 2"
            class="flex-grow-0 flex-shrink-0"
          >
            <v-toolbar-title class="mx-auto my-5">
              <router-link to="/">
                <v-img
                  contain
                  @click="
                    toTopGo();
                    CLR_BUSCAREPUESTO();
                  "
                  :src="`${domoapi2_img}Cia/15/logo?archivo=5.jpg`"
                  id="Home"
                  :class="[
                    {
                      'd-flex align-center mb-1':
                        $vuetify.breakpoint.name === 'xs',
                    },
                  ]"
                  :width="$vuetify.breakpoint.name === 'xs' ? 180 : 254"
                ></v-img>
              </router-link>
            </v-toolbar-title>
          </v-col>
          <v-col
            cols="8"
            style="min-width: 100px; max-width: 100%"
            class="flex-grow-1 flex-shrink-0 ma-3 mt-1 mx-12"
          >
            <!-- text buscar -->
            <v-col cols="12" md="10">
              <!-- buscar-->
              <v-text-field
                class="rounded-md"
                hide-details
                v-model.trim="txtArticulo"
                :label="`Buscar Productos...`"
                type="text"
                background-color="#EEEEEE"
                clearable
                clear-icon="mdi-close-circle"
                append-icon="mdi-magnify"
                @input="txtArticulo = txtArticulo.toUpperCase()"
                @click:append="
                  !IdTxtBuscar(txtArticulo) ? idBuscar(txtArticulo) : null
                "
                @keyup.enter="
                  !IdTxtBuscar(txtArticulo) ? idBuscar(txtArticulo) : null
                "
                required
                :loading="loading_buscar ? '#D3BC8D' : null"
                :error="ErrorBuscar"
                @click:clear="set_ErrorBuscar(false)"
                @keyup.esc="
                  !loading_buscar
                    ? (set_ErrorBuscar(false),
                      set_BuscarOverlay(false),
                      (txtArticulo = ''))
                    : null
                "
                dense
                outlined
                color="primary"
                single-line
              >
              </v-text-field>
            </v-col>

            <v-card
              v-if="$vuetify.breakpoint.width > 1050"
              class="mt-n3 d-flex justify-left"
              flat
            >
              <menuNav />
              <v-btn
                color="primary"
                light
                text
                plain
                to="/#Nosotros"
                :class="[
                  { 'mt-3': !Cliente.showOpc && $vuetify.breakpoint.lgAndDown },
                ]"
                v-if="$vuetify.breakpoint.width > 1050"
              >
                NOSOTROS
              </v-btn>
              <!-- testimonios-->

              <!-- contacto-->
              <v-btn
                color="primary"
                light
                text
                plain
                to="/#Contacto"
                :class="[
                  { 'mt-3': !Cliente.showOpc && $vuetify.breakpoint.lgAndDown },
                ]"
                v-if="$vuetify.breakpoint.width > 1050"
              >
                CONTACTO
              </v-btn>
              <v-btn
                color="primary"
                light
                text
                plain
                :class="[
                  { 'mt-3': !Cliente.showOpc && $vuetify.breakpoint.lgAndDown },
                ]"
                v-if="
                  dataUser.IndCargarPedido &&
                  $vuetify.breakpoint.width > 1050 &&
                  linkAgenda(dataUser.TipoUsuario)
                "
                @click="handleAgenda()"
              >
                AGENDA
              </v-btn>
              <v-spacer></v-spacer>
              <v-divider
                vertical
                inset
                v-if="dataUser.IndCargarPedido && !$vuetify.breakpoint.mdAndDown"
              ></v-divider>
              <!-- cliente opciones-->
              <v-card
                class="mt-3 d-flex align-end flex-column"
                flat
                tile
                v-if="
                  dataUser.IndCargarPedido && $vuetify.breakpoint.width > 1050
                "
              >
                <v-card class="d-flex flex-row-reverse" flat tile>
                  <v-card flat tile class="ml-2">
                    <v-menu
                      v-model="menuresumen"
                      v-if="Object.values(Cliente.resumen) != 0"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      offset-y
                      :position-x="x === 0 ? (x = 820) : x"
                      :position-y="y === 0 ? (y = 220) : y - 115"
                    >
                    <v-card width="290">
                        <v-toolbar dense class="elevation-0">
                          <v-toolbar-title
                          class="mx-3"
                            ><div class="black--text font-weight-black text-subtitle-1 mt-2">{{
                                  Cliente.data.Codigo
                                }}</div>
                                <div class="black--text font-weight-black text-subtitle-1 my-n1">
                                  {{
                                    Cliente.data.Nombre
                                  }}</div
                                ></v-toolbar-title
                          >

                          <v-spacer></v-spacer>

                          <v-btn icon @click="menuresumen = !menuresumen">
                            <v-icon color="accent" size="32">mdi-close</v-icon>
                          </v-btn>
                        </v-toolbar>
                        <v-list color="primary mt-1" dense dark>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="white--text d-flex justify-space-between">
                               <span
                                >Limite de Crédito</span>
                                <span class="text-subtitle-1 my-n1">
                                {{ simboloMoneda[tipoMoneda] }}
                                {{
                                  Cliente.resumen.LimiteCred[0] | numeral("0,0")
                                }}</span
                              >
                              </v-list-item-title>

                              <v-list-item-subtitle class="white--text text-subtitle-1">
                                {{ Cliente.resumen.CondicPago }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle 
                              v-if="Cliente.data.Descuento != 0"
                              class="mt-1 white--text  d-flex justify-space-between">
                              
                              <span
                              class="text-subtitle-2"
                                >Descuento</span>
                                <span class="text-subtitle-1 my-n1">
                                   {{
                                  Cliente.data.Descuento | numeral("0,0.00")
                                }}% </span>
                              
                              </v-list-item-subtitle>
                              
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-divider></v-divider>
                        <v-card-subtitle
                          :class="['text-center', 'font-weight-bold', 'my-n3', 'primary--text']"
                        >
                          ANALISIS DE VENCIMIENTO
                        </v-card-subtitle>
                        <v-divider></v-divider>
                        <v-list color="primary" dark dense>
                          <v-list-item>
                            <v-list-item-title> Pendiente </v-list-item-title>
                            <v-list-item-title :class="['text-right']">
                              {{ simboloMoneda[tipoMoneda] }}
                              {{
                                menuresumen
                                  ? Cliente.resumen.SaldoPendiente[tipoMoneda]
                                  : 0 | numeral("0,0")
                              }}
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-title> Vencido </v-list-item-title>
                            <v-list-item-title :class="['text-right']">
                              {{ simboloMoneda[tipoMoneda] }}
                              {{
                                menuresumen
                                  ? Cliente.resumen.SaldoVencido[tipoMoneda]
                                  : 0 | numeral("0,0")
                              }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                        <v-divider></v-divider>
                        <v-card-subtitle
                          :class="['text-center', 'font-weight-bold', 'my-n3', 'primary--text']"
                        >
                          PEDIDOS
                        </v-card-subtitle>
                        <v-divider></v-divider>
                        <v-list color="primary" dark dense>
                          <v-list-item>
                            <v-list-item-title> Transito </v-list-item-title>
                            <v-list-item-title :class="['text-right']">
                              {{ simboloMoneda[tipoMoneda] }}
                              {{
                                menuresumen
                                  ? Cliente.resumen.MontoPedTransito[tipoMoneda]
                                  : 0 | numeral("0,0")
                              }}
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-title> Backorder </v-list-item-title>
                            <v-list-item-title :class="['text-right']">
                              {{ simboloMoneda[tipoMoneda] }}
                              {{
                                menuresumen
                                  ? Cliente.resumen.MontoPedBackorder[
                                      tipoMoneda
                                    ]
                                  : 0 | numeral("0,0")
                              }}
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-title> Por Cobrar </v-list-item-title>
                            <v-list-item-title :class="['text-right']">
                              {{ simboloMoneda[tipoMoneda] }}
                              {{
                                menuresumen
                                  ? Cliente.resumen.MontoPedPenCobro[tipoMoneda]
                                  : 0 | numeral("0,0")
                              }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                        <v-divider></v-divider>
                        <div class="text-right ma-1">
                          <v-btn
                            color="secondary"
                            dark
                            @click="consolidado(Cliente.data.Codigo)"
                            small
                            class="elevation-0 primary--text font-weight-bold"
                            >ver mas
                          </v-btn>
                        </div>

                        <v-divider></v-divider>
                      </v-card>
                    </v-menu>
                  </v-card>
                  <v-card flat tile class="d-flex, flex-row-reverse">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-speed-dial
                          v-if="!Cliente.showOpc"
                          direction="bottom"
                          :open-on-hover="false"
                          transition="slide-y-reverse-transition"
                        >
                          <template v-slot:activator>
                            <v-btn
                              color="primary"
                              small
                              text
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-factory</v-icon>
                              <span
                                style="max-width: 240px"
                                :class="[
                                  'body-2',
                                  'font-weight-bold',
                                  'd-inline-block',
                                  'text-truncate',
                                ]"
                              >
                                ({{ Cliente.data.Codigo }})
                                {{ Cliente.data.Nombre }}
                              </span>
                            </v-btn>
                          </template>
                          <v-btn
                            v-if="dataUser.TipoUsuario !== 'C'"
                            dark
                            color="accent"
                            @click="dialogSelCliente(true)"
                            width="120"
                          >
                            <v-icon>mdi-swap-horizontal</v-icon>
                            CAMBIAR
                          </v-btn>
                          <v-btn
                            v-if="dataUser.TipoUsuario !== 'C'"
                            dark
                            color="accent"
                            @click="liberar_cliente()"
                            width="120"
                          >
                            <v-icon>mdi-arrow-right</v-icon>
                            LIBERAR
                          </v-btn>
                          <v-btn dark color="accent" width="120" @click="show">
                            <v-icon>mdi-note-text-outline</v-icon>
                            RESUMEN
                          </v-btn>
                          <v-btn
                            dark
                            color="accent"
                            width="120"
                            @click="consolidado(Cliente.data.Codigo)"
                          >
                            <v-icon>mdi-tab-plus</v-icon>
                            Ver Mas
                          </v-btn>
                        </v-speed-dial>
                      </template>
                      <span>{{
                        `(${Cliente.data.Codigo}) - ${Cliente.data.Nombre}`
                      }}</span>
                    </v-tooltip>
                  </v-card>
                  <v-card flat tile>
                    <v-chip
                      v-if="Cliente.showOpc && dataUser.TipoUsuario !== 'C'"
                      color="white"
                      class="ml-0 mr-n2 font-weight-bold"
                      style="color: #b05954"
                      label
                      small
                      @click.stop="dialogSelCliente(true)"
                      @click="show"
                    >
                      SELECCIONE CLIENTE
                    </v-chip>
                  </v-card>
                </v-card>
              </v-card>
              <v-divider
                vertical
                inset
                v-if="dataUser.IndCargarPedido && !$vuetify.breakpoint.mdAndDown"
              ></v-divider>
            </v-card>
          </v-col>
          <v-col
            cols="2"
            :class="[
              {
                'd-flex align-center mb-6': !dataUser.IndAutenticado,
              },
            ]"
            class="flex-grow-1 mt-3"
          >
            <div class="d-flex flex-column-reverse">
              <v-card class="pa-1" v-if="$vuetify.breakpoint.width > 1050" flat>
                <!-- usuario-->

                <v-menu
                  bottom
                  origin="center center"
                  transition="slide-y-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="dataUser.IndAutenticado ? null : logshow()"
                      plain
                      class="pa-3 black--text"
                      small
                      dark
                      v-on="on"
                    >
                      <v-icon color="primary">mdi-account-circle</v-icon>
                      <span
                        style="color: #75787b; max-width: 100px"
                        class="
                          float-right
                          font-weight-bold
                          d-inline-block
                          text-truncate
                        "
                      >
                        {{
                          dataUser.IndAutenticado
                            ? dataUser.NombreUsu
                            : "INGRESAR"
                        }}</span
                      >
                    </v-btn>
                  </template>
                  <v-list
                    dense
                    color="primary"
                    dark
                    v-if="dataUser.IndAutenticado"
                  >
                    <!-- Descomentar cuando definan el proceso de mantenimeinto WEB
        no se muestra-->

                    <v-list-item
                      v-if="dataUser.IndAutenticado && dataUser.IndMantGaleria"
                      to="/mantenimiento/"
                    >
                      <v-icon left>mdi-cog</v-icon>
                      <v-list-item-title class="font-weight-bold"
                        >MANTENIMIENTOS
                      </v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>

                    <v-list-item @click="openDlgChangePass">
                      <v-icon left>mdi-lock-reset</v-icon>
                      <v-list-item-title>CAMBIAR CONTRASEÑA</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item @click="logshow">
                      <v-icon left>mdi-exit-to-app</v-icon>
                      <v-list-item-title>SALIR</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card>
              <v-card class="pa-1 hidden-sm-and-down" flat>
                <v-badge
                  v-if="
                    dataUser.IndAutenticado &&
                    !Cliente.showOpc &&
                    dataUser.VerPrecios[tipoMoneda]
                  "
                  :color="
                    Pedido.data.TotItem && Pedido.data.TotItem !== 0
                      ? 'info'
                      : 'transparent'
                  "
                  inline
                  bottom
                  left
                  overlap
                  :content="
                    Pedido.data.TotItem && Pedido.data.TotItem !== 0
                      ? TotalPedido
                      : 0
                  "
                >
                </v-badge>
                <v-badge
                  v-if="
                    dataUser.IndAutenticado &&
                    !Cliente.showOpc &&
                    dataUser.VerPrecios[tipoMoneda] &&
                    Pedido.data.TotItem !== 0
                  "
                  bordered
                  :color="
                    Pedido.data.TotItem && Pedido.data.TotItem !== 0
                      ? 'accent'
                      : 'transparent'
                  "
                  icon="mdi-lock"
                  overlap
                >
                  <template v-slot:badge>
                    <span class="white--text">{{
                      Pedido.data.TotItem !== 0 ? Pedido.data.TotItem : ""
                    }}</span>
                  </template>
                  <v-icon large color="primary" @click="openDrawerCar">
                    mdi-cart-variant
                  </v-icon>
                </v-badge>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-dialog
        v-if="$vuetify.breakpoint.width < 1050"
        v-model="dialog"
        max-width="350"
      >
        <v-card class="elevation-12" color="primary">
          <v-toolbar dark dense flat color="white">
            <v-toolbar-title>
              <v-img
                contain
                :src="`${domoapi2_img}Cia/15/logo?archivo=1.png`"
                id="Home"
                width="154"
              ></v-img>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon @click="dialog = false" dark>
              <v-icon color="primary" large>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <!-- Usuario Menu movil -->
          <span
            v-if="dataUser.IndAutenticado"
            class="ml-2 font-weight-regular secondary--text"
          >
            {{ dataUser.NombreUsu }}
          </span>
          <div>
            <v-btn
              @click="openDlgChangePass"
              text
              color="white"
              v-if="dataUser.IndAutenticado"
            >
              <v-icon left>mdi-lock-reset</v-icon>
              CAMBIAR CONTRASEÑA
            </v-btn>
            <v-btn @click="logshow" text color="white">
              <v-icon left v-if="dataUser.IndAutenticado"
                >mdi-exit-to-app</v-icon
              >
              <v-icon left v-if="!dataUser.IndAutenticado">mdi-account</v-icon>
              {{ !dataUser.IndAutenticado ? "INGRESAR" : "salir" }}
            </v-btn>
          </div>

          
          <v-divider v-if="dataUser.IndAutenticado" color="#D3BC8D"></v-divider>

          <!-- Cliente Menu movil -->
          <v-list-item link v-if="dataUser.IndAutenticado">
            <v-list-item-content
              v-if="Cliente.showOpc && dataUser.TipoUsuario !== 'C'"
              @click.stop="dialogSelCliente(true)"
            >
              <v-list-item-title class="white--text">
                <v-icon color="secondary" dark left> mdi-factory </v-icon>
                Seleccione Cliente
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item two-line v-if="!Cliente.showOpc" link>
              <v-menu
                offset-y
                rounded
                v-if="Object.values(Cliente.resumen) !== 0"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-content v-bind="attrs" v-on="on">
                    <v-list-item-title class="white--text">
                      <v-icon color="secondary" dark left> mdi-factory </v-icon>
                      {{
                        Cliente.data ? Cliente.data.Nombre : ""
                      }}</v-list-item-title
                    >
                    <v-list-item-subtitle class="white--text">
                      ({{ Cliente.data ? Cliente.data.Codigo : "" }})
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <v-list color="primary" dark dense>
                  <v-list-item
                    v-if="dataUser.TipoUsuario !== 'C'"
                    @click="dialogSelCliente(true)"
                  >
                    <v-list-item-avatar>
                      <v-icon>mdi-swap-horizontal</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>CAMBIAR</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    v-if="dataUser.TipoUsuario !== 'C'"
                    @click="liberar_cliente()"
                  >
                    <v-list-item-avatar>
                      <v-icon>mdi-arrow-right</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>LIBERAR</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- en mobil no muestra resumen va directo a ver mas
                  <v-list-item @click=" 
                  consolidado(Cliente.data.Codigo);
                      dialog = false;">
                    <v-list-item-avatar>
                      <v-icon>mdi-note-text-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>RESUMEN</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
-->
                  <v-list-item
                    @click="
                      consolidado(Cliente.data.Codigo);
                      dialog = false;
                    "
                  >
                    <v-list-item-avatar>
                      <v-icon>mdi-tab-plus</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>VER MAS</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item>
          </v-list-item>

          <v-divider
            v-if="dataUser.IndAutenticado && dataUser.TipoUsuario !== 'C'"
            color="#D3BC8D"
          ></v-divider>

          <!-- Menu Principal -->
          <v-list v-if="$vuetify.breakpoint.width <= 1050" dense>
            <v-list-item-group>
              <v-list-item to="/#Inicio" @click="dialog = false">
                <v-list-item-content>
                  <v-list-item-title> INICIO </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="mt-n3">
                <v-list-item-content>
                  <v-list-item-title> PRODUCTOS </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item-group class="mt-n3">
                <v-list-item
                  v-for="(item, index) in categorias"
                  :key="index"
                  @click="
                    idSubCat(item.CodigoDiv, item.CodigoDep, item.Categoria);
                    CLR_DATOS_SUBCAT();
                    CLR_BUSCARPROMO();
                    CLR_BUSCARSCAT();
                    CLR_BUSCARMARCA();
                    CLR_BUSCAREPUESTO();
                  "
                  :to="`/subcategoria/${item.CodigoDiv}/${item.CodigoDep}/${item.Categoria}`"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.Nombre }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>

              <v-list-item to="/#Nosotros" @click="dialog = false">
                <v-list-item-content>
                  <v-list-item-title>NOSOTROS</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item to="/#Contacto" @click="dialog = false">
                <v-list-item-content>
                  <v-list-item-title>CONTACTO</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                @click="handleAgenda()"
                v-if="dataUser.IndAutenticado && linkAgenda(dataUser.Usuario)"
              >
                <v-list-item-content>
                  <v-list-item-title>AGENDA</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                :to="`/mantenimiento/`"
                @click="dialog = false"
                v-if="dataUser.IndAutenticado && dataUser.IndMantGaleria"
              >
                <v-list-item-content>
                  <v-list-item-title>MANTENIMIENTOS</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-dialog>
    </v-app-bar>
    <v-navigation-drawer
    :class="{'drawer-content': drawerCar}"
      width="25vw"
      height="100vh"
      v-model="drawerCar"
      app
      fixed
      clipped
      right
      temporary
    >
    <div class="pa-1">
     <CarritoVue :isdrawer="true" />
    </div>
     
      <template v-slot:prepend>
        <ClienteShop /> 
      
        <ResumenShop />
         <InfoEmbajale />
        <v-card
        v-if="Object.values(Pedido.items).length === 0"
      :class="['mx-auto', 'elevation-0', 'my-5', 'text-center']"
      width="290px"
      outlined
    >
      <v-card-title class="font-weight-bold text-wrap"
        >¡Tu carrito en DOMODECO está vacío!</v-card-title
      >
      <v-icon size="50">mdi-cart-variant</v-icon>
    </v-card>
        <div class="pa-1" v-if="Object.values(Pedido.items).length !== 0">
          <v-btn
            color="accent"
            dark
            block
            small
            elevation="0"
            @click="
              drawerCar = false;
              toTopGo();
              toCar();
            "
          >
            ir al detalle para confirmar
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-navigation-drawer
      width="65vw"
      v-model="openDrawer"
      app
      fixed
      clipped
      height="100vh"
      right
      v-if="$vuetify.breakpoint.width < 1050 && openDrawer"
    >
    <template v-slot:prepend>
        <v-list-item two-line class="grey lighten-3">
          <v-list-item-avatar v-if="dataUser.IndAutenticado">
           <v-icon large>mdi-account-circle</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title> {{ dataUser.IndAutenticado ? "Bienvenido " : "DOMOSA DECORACIONES" }}</v-list-item-title>
            <v-list-item-subtitle  v-if="dataUser.IndAutenticado"> {{ dataUser.NombreUsu }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>
      <v-list-item
        dense
        class="primary white--text"
        v-if="
          dataUser.IndAutenticado &&
          Cliente.showOpc &&
          dataUser.TipoUsuario !== 'C'
        "
        @click.stop="dialogSelCliente(true)"
      >
        <v-list-item-content>
          <v-list-item-title>SELECCIONE CLIENTE</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group
        class="primary"
        append-icon="mdi-chevron-down"
        active-class="primary darken-1"
        no-action
        :value="false"
        v-if="!Cliente.showOpc && dataUser.IndAutenticado"
      >
        <template v-slot:activator>
          <v-list-item two-line dense class="mx-n4">
            <v-list-item-content >
              <v-list-item-title class="white--text">
                {{ Cliente.data ? Cliente.data.Nombre : "" }}</v-list-item-title
              >
              <v-list-item-subtitle class="white--text">
                {{
                  Cliente.data ? Cliente.data.Codigo : ""
                }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-divider color="#D3BC8D"></v-divider>
        <v-list dense>
          <v-list-item
          dark
            link
            v-if="dataUser.TipoUsuario !== 'C'"
            @click="dialogSelCliente(true)"
          >
            <v-list-item-content >
              <v-list-item-title>CAMBIAR</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider color="#D3BC8D"></v-divider>
          <v-list-item
            link
            dark
            v-if="dataUser.TipoUsuario !== 'C'"
            @click="liberar_cliente()"
          >
            <v-list-item-content>
              <v-list-item-title>LIBERAR</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider color="#D3BC8D"></v-divider>
          <v-list-item link @click="consolidado(Cliente.data.Codigo)" dark>
            <v-list-item-content>
              <v-list-item-title>VER MAS</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-group>
      <DrawerMenu />
      <footer>
        <div>
          <div class="mt-2 pa-2 mb-1">
            <v-btn
              @click="openDlgChangePass"
              block
              color="#c8c8c8"
              small
              elevation="0"
              v-if="dataUser.IndAutenticado"
            >
              <v-icon left>mdi-lock-reset</v-icon>
              CAMBIAR CONTRASEÑA
            </v-btn>
          </div>
          <div class="pa-2">
            <v-btn @click="logshow" color="error" block small elevation="0">
              <v-icon left v-if="dataUser.IndAutenticado"
                >mdi-exit-to-app</v-icon
              >
              <v-icon left v-if="!dataUser.IndAutenticado">mdi-account</v-icon>
              {{ !dataUser.IndAutenticado ? "INGRESAR" : "salir" }}
            </v-btn>
          </div>
        </div>
      </footer>
  </v-navigation-drawer>

    <!-- ventana sesion dialogo cierre por inactividad-->
    <v-dialog
      persistent
      v-model="dialogSession"
      transition="dialog-top-transition"
      max-width="380"
      v-if="dialogSession === true"
    >
      <v-card class="elevation-12" color="warning" dark>
        <v-toolbar dark flat width="380" color="white">
          <v-toolbar-title>
            <v-img
              contain
              :src="`${domoapi2_img}Cia/15/logo?archivo=1.png`"
              id="Home"
              width="154"
            ></v-img>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogSession = false" light>
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-center">
          <v-card-subtitle>
            <v-icon size="30" color="primary">mdi-alert-circle-outline</v-icon>
            Sesión finalizada por inactividad!
          </v-card-subtitle>
        </v-card-text>

        <v-divider color="#D3BC8D"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            elevation="0"
            dark
            @click="dialogSession = false"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Ventana Cambio de Clave -->
    <DialogChangePassword
      :opendlg="openDialogoChPass"
      :closedlg="exitResetPass"
      :dataUser="dataUser"
      :key="keyId"
    />

    <!-- Ventana Autenticacion -->
    <v-dialog
      class="rss"
      v-if="!dataUser.IndAutenticado"
      v-model="ShowLogin"
      persistent
      max-width="380"
    >
      <v-card class="elevation-12" color="warning" dark>
        <v-toolbar dark flat width="380" color="white">
          <v-toolbar-title>
            <v-img
              contain
              :src="`${domoapi2_img}Cia/15/logo?archivo=1.png`"
              id="Home"
              width="154"
            ></v-img>
          </v-toolbar-title>

          <v-spacer></v-spacer>
          <v-btn icon @click="ShowLogin = false">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-center">
          <v-form id="login-form" ref="form">
            <v-text-field
              label="Usuario"
              name="usuario"
              prepend-icon="mdi-account"
              type="text"
              v-model="ModelLogin.usuario"
              required
              @keyup.enter="login"
              :disabled="ProcessLogin"
            ></v-text-field>

            <v-text-field
              id="clave"
              label="Contraseña"
              name="clave"
              prepend-icon="mdi-lock"
              v-model="ModelLogin.clave"
              required
              @keyup.enter="login"
              :disabled="ProcessLogin"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
            ></v-text-field>

            <v-alert
              v-if="!statusLogin && !ProcessLogin && dataUser.Mensaje != ''"
              :class="['mx-auto', 'text-caption']"
              dense
              color="accent"
              width="200"
            >
              {{ dataUser.Mensaje }}
            </v-alert>
          </v-form>
        </v-card-text>
        <v-progress-linear
          v-if="ProcessLogin"
          indeterminate
          color="secondary"
          class="mb-0"
        ></v-progress-linear>
        <v-divider color="#D3BC8D"></v-divider>
        <v-card-actions class="d-flex flex-row-reverse">
          <v-btn
            color="primary"
          
            @click="login"
            :disabled="ProcessLogin"
          >
          Acceder
          </v-btn>
          
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ventana Cierra sesión -->
    <v-dialog
      v-if="dataUser.IndAutenticado"
      v-model="ShowLogin"
      persistent
      max-width="380"
    >
      <v-card class="elevation-12" color="warning" dark>
        <v-toolbar dark flat width="380" color="white">
          <v-toolbar-title>
            <v-img
              contain
              :src="`${domoapi2_img}Cia/15/logo?archivo=1.png`"
              id="Home"
              width="154"
            ></v-img>
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon @click="ShowLogin = false" light>
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-center">
          <v-card-subtitle>
            Esta seguro que desea cerrar sesión?
          </v-card-subtitle>
        </v-card-text>

        <v-progress-linear
          v-if="ProcessLogin"
          indeterminate
          color="#D3BC8D"
          class="mb-0"
        ></v-progress-linear>
        <v-divider color="#D3BC8D"></v-divider>
        <v-card-actions class="d-flex flex-row-reverse">
         
          <v-btn
          
            elevation="0"
        color="primary"
            @click="logout"
            :disabled="ProcessLogin"
          >
            Si
          </v-btn>
          <v-btn
            elevation="0"
            color="white"
            @click="ShowLogin = false"
            :disabled="ProcessLogin"
            outlined
            class="mr-4"
          >
            No
          </v-btn> 
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Boton subir-->
    <v-fab-transition>
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        :dark="bottoncolor === false"
        fixed
        bottom
        right
        small
        color="accent"
        class="elevation-0"
        @click="toTop"
      >
        <div
          class="d-flex flex-column caption d-inline-block text-truncate"
          style="max-width: 100px"
        >
          <v-icon class="mx-auto" size="25">mdi-chevron-up</v-icon>
        </div>
      </v-btn>
    </v-fab-transition>
    <!-- Boton rss -->
    <v-fab-transition>
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        v-if="$vuetify.breakpoint.smAndUp"
        fixed
        bottom
        left
        small
        color="#FD1D1D"
        class="elevation-0"
        target="_blank"
        href="https://www.instagram.com/domosadecoraciones/"
      >
        <div
          class="d-flex flex-column caption d-inline-block text-truncate"
          style="max-width: 100px"
        >
          <v-icon size="25" color="white">mdi-instagram</v-icon>
        </div>
      </v-btn>
    </v-fab-transition>

    <!-- Ventana Seleccion Cliente -->
    <v-dialog v-model="ShowCliente" persistent max-width="580">
      <v-card color="warning" dark min-height="400">
        <v-toolbar dark flat width="580" color="white">
          <v-toolbar-title>
            <v-img
              contain
              :src="`${domoapi2_img}Cia/15/logo?archivo=1.png`"
              width="154"
            ></v-img>
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon @click="dialogSelCliente(false)" color="primary">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text :class="['pt-4']">
          <v-text-field
            type="text"
            v-model="txtCliente"
            label="Buscar Cliente"
            outlined
            clearable
            clear-icon="mdi-close-circle"
            append-outer-icon="mdi-magnify"
            @click:append-outer="
              get_BuscaClientes(txtCliente);
              TextPed = '';
            "
            :loading="loading ? '#D3BC8D' : null"
            @keyup.enter="
              get_BuscaClientes(txtCliente);
              TextPed = '';
            "
            autofocus
          ></v-text-field>
        </v-card-text>
        <!-- -->
        <v-card-text
          v-if="
            Object.entries(Pendientes).length !== 0 ||
            Object.entries(Cliente.search).length !== 0
          "
          style="height: 250px"
        >
          <div
            v-if="dataUser.PedidosPend != 0"
            class="
              text-center text-subtitle-2
              mt-n10
              mb-3
              font-weight-bold
              primary--text
            "
          >
            <v-progress-circular
              indeterminate
              color="accent"
              size="20"
              v-if="Pendientes.length === 0"
            ></v-progress-circular>
            {{
              txtCliente.length === 0
                ? dataUser.PedidosPend !== 0
                  ? (TextPed = "PEDIDOS PENDIENTES POR CONFIRMAR")
                  : ""
                : TextPed
            }}
          </div>
          <v-virtual-scroll
            v-show="!loading"
            :items="txtCliente.length !== 0 ? Cliente.search : Pendientes"
            :item-height="45"
            height="250"
            :class="['mt-n4']"
          >
            <template v-slot="{ item }">
              <v-list-item
                @click="
                  select_cliente(item.Codigo);
                  set_changeCliente();
                "
              >
                <v-list-item-avatar>
                  <v-icon style="color: #d3bc8d">mdi-factory</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    >{{ item.Nombre }} ({{ item.Codigo }}) /
                    {{ item.Rif }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-virtual-scroll>
        </v-card-text>

        <v-card-text
          v-if="Cliente.search.length === 0 && txtCliente.length != 0"
          :class="['text-center mt-n12', 'text-h4']"
        >
          SIN RESULTADOS
        </v-card-text>
        <v-spacer
          :style="
            dataUser.PedidosPend !== 0
              ? 'padding-top: 2px;'
              : 'padding-top: 145px;'
          "
        ></v-spacer>
        <v-divider color="#D3BC8D"></v-divider>
        <v-card-actions>
          <v-list-item>
            <v-row align="center" justify="end">
              <v-btn
                color="primary"
                @click="dialogSelCliente(false)"
                elevation="0"
              >
                Cerrar
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-main>
      <transition>
        <router-view :key="$route.fullPath" />
      </transition>
      <v-overlay :value="BuscarOverlay">
        <v-progress-circular
          v-if="ErrorBuscar === false"
          indeterminate
          size="40"
          width="3"
          color="primary"
        ></v-progress-circular>
        <v-btn
          v-else
          color="red darken-4"
          @click="
            set_BuscarOverlay(false);
            set_ErrorBuscar(false);
          "
        >
          <v-icon class="ml-n2">mdi-alert</v-icon>
          <span class="ml-2"> Sin Resultados X </span></v-btn
        >
        <span style="color: '#4d6572'" class="ml-2 body-1 font-weight-normal"
          >{{ ErrorBuscar ? "" : "Por Favor, Espere..." }}
        </span>
      </v-overlay>
    </v-main>
    <!-- para manejar la inactividad
    eventos como mouse y key press-->
    <v-idle
      class="d-none"
      @idle="onidle"
      v-if="dataUser.IndAutenticado"
      :loop="false"
      :reminders="[10, 15]"
      :wait="5"
      :duration="3600"
    />
    <!-- 
      3600seg =  1h 60min
      duracion en segundos 60 min * 60 seg
      -->

    <ContratoCliente />
    <DomoFooterVue />
  </v-app>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import menuNav from "@/components/MenuNavegacion";
import ContratoCliente from "@/components/ContratoCliente";
import DomoFooterVue from "@/components/DomoFooter";
import DomoFooterVueMobile from "@/components/DomoFooterMobile";
import { DialogChangePassword } from "@/components/Dialogs";
import { DrawerMenu } from "@/components/Drawer";
import { ClienteShop, ResumenShop } from "@/components/DrawerCar";
import CarritoVue from "@/components/CarritoMovil/Carrito";
import InfoEmbajale from "@/components/CarritoMovil/InfoEmbajale"

export default {
  name: "App",

  components: {
    CarritoVue,
    menuNav,
    ContratoCliente,
    DomoFooterVue,
    DomoFooterVueMobile,
    DialogChangePassword,
    DrawerMenu,
    ClienteShop,
    ResumenShop,
    InfoEmbajale
  },
  props: {
    source: String,
  },
  destroyed() {
    this.controller.abort();
  },
  data() {
    return {
      show1: false,
      drawerCar: false,
      controller: new AbortController(),
      dialog: false,
      id: 1,
      filterFrom: false,
      ShowLogin: false,
      ShowPassReset: false,
      ProcessLogin: false,
      ShowCliente: false,
      ShowBuscar: false,
      dialogSession: false,
      txtCliente: "",
      txtArticulo: "",
      menumovil: false,
      menubuscar: false,
      menuresumen: false,
      menu: false,
      x: 0,
      y: 0,
      fab: false,
      fabcli: false,
      bottoncolor: false,
      TextPed: "",
      loading_buscar: false,
      updatePag: 0,
      statusLogin: false,
      newPassword: "",
      currentPassword: "",
      shownewpass: false,
      showoldpass: false,
      keyId: 0,
    };
  },
  methods: {
    ...mapMutations("mod_agendaquery", [
      "clr_dsAgendaVisitasCombo",
      "clr_dsAgendaVisitas",
      "clr_idCliente",
    ]),
    ...mapMutations([
      "CLR_DISPONIBLE",
      "clr_dsEstadistica",
      "CLR_BUSCAREPUESTO",
      "setTabAgenda",
      "set_disableNav",
      "GET_BUSCAREPUESTO",
      "CLR_DATOS_SUBCATB",
      "set_tabBusqueda",
      "set_tipoB",
      "set_AdPromoF",
      "set_changeSubcatF",
      "set_Pendientes",
      "set_ModelLogin",
      "set_dataUser",
      "set_Cliente",
      "set_Pedido",
      "set_mnuCategorias",
      "set_varCategorias",
      "set_SubCategorias",
      "set_subcategoria",
      "CLR_DATOS_SUBCAT",
      "SET_DATOS_SUBCAT_ALL",
      "CLR_BUSCARSCAT",
      "SET_DATOS_SUBCAT_MARCA",
      "CLR_BUSCARMARCA",
      "CLR_BUSCARMARCAtt",
      "CLR_PRECIO",
      "CLR_DATOS_ART",
      "CLR_PROMO",
      "set_mensaje",
      "CLR_BUSCARQUERY",
      "CRL_DetalleCliente",
      "set_changeCliente",
      "set_ErrorBuscar",
      "CLR_BUSCARPROMO",
      "CLR_ERROR_AXIOS",
      "CLR_BUSCARSCATall",
      "GET_BUSCARSCAT",
      "GET_BUSCARCAT",
      "set_BuscarOverlay",
      "setDrawerMovil",
    ]),
    ...mapActions([
      "cargarFeature",
      "cargarMaestro",
      "get_Autenticacion",
      "get_pedidosPendientes",
      "get_BuscaClientes",
      "get_ResumenCliente",
      "get_ConsultaPedido",
      "get_mnuCategorias",
      "get_SubCategorias",
      "consolidadoSCategoria",
      "cargarDatosMarcaCat",
      "get_BuscaArticulo",
      "cargarDatosPromo",
      "cargarDatosArt",
    ]),
    openDrawerCar() {
      if (this.$route.name !== "CarritoCompras") this.drawerCar = true;
    },
    openDlgChangePass() {
      this.currentPassword = "";
      this.newPassword = "";
      this.ShowPassReset = true;
      this.keyId = Math.floor(Math.random() * 10);
    
    },
    handleAgenda() {
      this.dialog = false;
      this.$router.push({ path: `/agenda/` }).catch((err) => {});
      this.setTabAgenda(0);
    },
    updateText(newValue) {
      this.value = newValue.toUpperCase();
    },
    async rerender() {

      this.id++;
      if(this.$route.name === "Categoria")
      await this.cargarDatosPromo({ codart: this.$route.params.codart })
      if(this.$route.name === "Producto")
        await this.cargarDatosArt({ codart: this.$route.params.codart })
     
      if(this.$route.name === "Articulos")
       await this.get_BuscaArticulo(this.$route.params.txtbuscar)
      this.set_BuscarOverlay(false);
    },
    show(e) {
      e.preventDefault();

      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.menuresumen = true;
      });
    },
    onidle() {
      this.dialogSession = true;
      this.logout();

    },
    onremind(time) {
      // alert seconds remaining to 00:00
      alert(time);
    },
    consolidado(codCli) {
      this.toTopGo();
      const path = "/cliente/" + codCli;
      return this.$route.path !== path ? this.$router.push(path) : false;
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
      var scrollPoint = window.scrollY + window.innerHeight;
      var totalPageHeight = document.body.scrollHeight;
     
      if (scrollPoint >= totalPageHeight) 
        this.bottoncolor = true;

      
    },
    toTop() {
      this.$vuetify.goTo(0);
      this.bottoncolor = false;
    },
    toTopGo() {
      window.scrollTo(0, 0);
      this.set_AdPromoF();
    },
    toCar() {
      this.$router.push({ path: `/Carrito/` }).catch((err) => {});
    },

    exitResetPass() {
      if (this.dataUser.IndCambioClave) this.dataUser.IndCambioClave = false;
      else this.ShowPassReset = false;
    },


    async login() {
      if (this.ModelLogin.usuario && this.ModelLogin.clave) {
        this.ProcessLogin = true;
        this.statusLogin = false;

        await this.get_Autenticacion();

        if (this.dataUser.IndAutenticado) {
          this.ShowLogin = false;
          this.set_ModelLogin({
            usuario: "",
            clave: "",
            programa: "siga_xml",
          });

          if (this.$route.name === "Detalle") {
            await this.cargarDatosArt({ codart: this.$route.params.articulo });
          }
          if (this.$route.name === "Categoria") {
            await this.consolidadoSCategoria({
              signal: this.controller.signal,
            });
          }
        }
        if (this.dataUser.PedidosPend !== 0) {
          await this.get_pedidosPendientes();
        }
        this.ProcessLogin = false;
      }
    },
    async logout() {
      this.set_Pendientes([]);
      this.ProcessLogin = true;
      //limpio filtro de filtro
      this.CLR_BUSCARPROMO();
      //limpio variables refrentes a la agenda de visitas
      this.CLR_DISPONIBLE()
      this.clr_dsAgendaVisitasCombo();
      this.clr_idCliente();
      this.clr_dsAgendaVisitas();

      this.set_ModelLogin({
        usuario: "invitado",
        clave: "invitado",
        programa: "siga_xml",
      });

      await this.login();
      await this.liberar_cliente();
      this.ShowLogin = false;

      if (this.$route.meta.Autenticado) {
        if (!this.dataUser.IndAutenticado) 
          this.$router.push({ path: `/` });
        
      }

      this.ProcessLogin = false;
      this.rerender();
    },
    logshow() {
      this.statusLogin = true;
      this.setDrawerMovil(false)
      this.show1 = false;
      this.set_ModelLogin({
        usuario: "",
        clave: "",
        programa: "siga_xml",
      });
      this.ShowLogin = true;
      this.dialog = false;
    },
    idSubCat(Div, Dep, Cat) {
      this.GET_BUSCARCAT(Cat);
      window.scrollTo(0, 0);
      this.CLR_ERROR_AXIOS();
      this.CLR_DATOS_SUBCATB();
      this.CLR_BUSCAREPUESTO();
      this.set_changeSubcatF();
      this.CLR_DATOS_ART();
      // this.CLR_PROMO();
      this.set_AdPromoF();
      this.set_varCategorias([Div, Dep, Cat]);
      // if (!this.$route.params.codart) this.consolidadoSCategoria({signal: this.controller.signal,});
      if (this.$route.params.cat)
        //  console.log("f5");
        this.dialog = false;
    },
    async idBuscar(txtArt) {
      if (txtArt != "") {
        await this.set_BuscarOverlay(true);
        this.loading_buscar = true;
        //async this.get_BuscaArticulo(txtArt)
        if (await this.get_BuscaArticulo(txtArt)) {
          this.$router
            .push({
              path: `/articulos/${encodeURIComponent(txtArt)}`,
            })
            .catch((err) => {});

          window.scrollTo(0, 0);
          this.ShowBuscar = false;
          this.dialog = false;
          this.txtArticulo = "";
          this.menubuscar = false;
          this.set_ErrorBuscar(false);

          this.CLR_BUSCARPROMO();
        } else {
          this.set_ErrorBuscar(true);
        }
        this.loading_buscar = false;
      }
      this.loading_buscar = false;
    },
    dialogSelCliente(show) {
      this.ShowCliente = show;
      this.txtCliente = "";
      this.TextPed = "";
      if (show) {
        this.set_Cliente({
          showOpc: this.Cliente.showOpc,
          data: this.Cliente.data,
          search: this.Pendientes,
          resumen: this.Cliente.resumen,
        });
        this.TextPed = "PEDIDOS PENDIENTES POR CONFIRMAR";
        if (this.dataUser.PedidosPend !== 0) {
          this.get_pedidosPendientes();
        }
      }
    },
    async select_cliente(codigo_cliente) {
      this.set_BuscarOverlay(true);
      const xCliente =
        Object.entries(await this.Cliente.search).length !== 0
          ? await this.Cliente.search.filter(
              (x) => x.Codigo === codigo_cliente
            )[0]
          : await this.Pendientes.filter((x) => x.Codigo === codigo_cliente)[0];
      this.set_Cliente({
        showOpc: false,
        data: xCliente,
        search: [],
        resumen: {},
      });
      this.set_changeCliente();
      this.CRL_DetalleCliente();
      this.dialogSelCliente(false);
      await this.get_ResumenCliente();
      await this.get_ConsultaPedido();
      this.menuresumen = true;
      if (this.dataUser.PedidosPend !== 0) {
        await this.get_pedidosPendientes();
      }
      //this.$route.name != "Cliente" ? this.$router.go() : null

      this.rerender();
      this.clr_dsEstadistica();
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    liberar_cliente() {
      this.menuresumen = false;
      this.dialog = false;
      this.set_Cliente({
        showOpc: true,
        data: {
          Codigo: "",
          Descuento: 0,
          GrupoCliente: 0,
          Nombre: "",
          Rif: "",
          Siglas: "",
          Vendedor: "",
        },
        search: [],
        resumen: {},
      });
      this.set_Pedido({
        data: {},
        items: [],
      });
      if (this.$route.meta.Autenticado) {
        if (this.Cliente.showOpc) {
          this.$router.push({
            path: `/`,
            //query: { redirect: to.fullPath }
          });
        }
      }
    },
  },
  computed: {
    ...mapState([
      "BuscarOverlay",
      "arrayUserAgenda",
      "ttCatalogo",
      "pageMode",
      "ModelLogin",
      "dataUser",
      "maestro",
      "Cliente",
      "Pedido",
      "tipoMoneda",
      "simboloMoneda",
      "btnrssicon",
      "user",
      "categoria",
      "loading_cat",
      "loading",
      "mnuCategorias",
      "SubCategorias",
      "ttArticuloAll",
      "ttMarcas",
      "errored",
      "CarOverlay",
      "CarMsj",
      "Pendientes",
      "idleVue",
      "ErrorBuscar",
      "filter",
      "domoapi2_img",
      "drawerMovil",
    ]),
    ...mapGetters(["filterconsolidado"]),
    isIdle() {
      return this.idleVue.isIdle;
    },
    openDrawer: {
      get() {
        return this.drawerMovil;
      },
      set(val) {
        this.setDrawerMovil(val);
      },
    },
    openDialogoChPass() {
      if (this.dataUser.IndCambioClave)
        this.ShowPassReset = this.dataUser.IndCambioClave;
      return this.ShowPassReset;
    },
    categorias() {
      let cat = [];
      const { ttCategoria } = this.maestro || {};
      if (ttCategoria !== undefined) cat = ttCategoria;

      return cat;
    },
    linkAgenda: function () {
      return function (value) {
        return value !== "C";
      };
    }, //
    IdTxtBuscar: function () {
      return function (value) {
        if (this.$route.params.txtbuscar === value) return true;
      };
    },
    numMaqui: function () {
      return function (id) {
        if (this.ttCatalogo) {
          if (id === 0)
            return this.ttCatalogo
              .filter((x) => x.Catalogo === "Maquina")
              .map((x) => x.JsonItem);
          if (id === 1)
            return this.ttCatalogo
              .filter((x) => x.Catalogo === "Repuesto")
              .map((x) => x.JsonItem);
        }
      };
    },
    nameR() {
      return this.$route.name;
    },
    TotalPedido() {
      let numeral = require("numeral");
      let monto = numeral(this.Pedido.data.MontoTotal[this.tipoMoneda]).format(
        "0,0.00"
      );
      return this.simboloMoneda[this.tipoMoneda] + " " + monto;
    },
  },
  created() {
    // this.get_mnuCategorias();
    this.cargarMaestro();
  },

  mounted() {
    if (window.sessionStorage.getItem("datauser")) {
      this.set_dataUser(JSON.parse(window.sessionStorage.getItem("datauser")));
    } else {
      //this.logout();
    }
    if (window.sessionStorage.getItem("cliente")) {
      this.set_Cliente(JSON.parse(window.sessionStorage.getItem("cliente")));
      this.get_ConsultaPedido();
    }
  },
  watch: {
    CarOverlay(val) {
      val &&
        setTimeout(() => {
          this.set_mensaje({
            Visible: false,
            Msj: "",
            Type: "",
          });
        }, 3000);
    },
    $route(to, from) {

      if (this.$route.meta.Autenticado) {
        if (!this.dataUser.IndAutenticado || this.Cliente.showOpc) {
          this.$router.push({
            path: `/`,
            //query: { redirect: to.fullPath }
          });
        }
      }
      if (from.name === "Cliente") {
        this.set_disableNav(true);
      }

      //refreco pagina busqueda
      if (this.$route.name === "Articulos" && from.name === null) {
        this.idBuscar(this.$route.params.txtbuscar);
        this.set_BuscarOverlay(true);
      }

      if (this.$route.params.cat) {
        window.scrollTo(0, 0);
        this.GET_BUSCARSCAT(JSON.parse(window.localStorage.getItem("subcat")));

        window.scrollTo(0, 0);
        if (from.name === null) {
          this.idSubCat(
            this.$route.params.div,
            this.$route.params.dep,
            this.$route.params.cat
          );
        }
      }
    },
    deep: true,
    immediate: true,
  },
  updated() {
    if (this.menuresumen) {
      this.dialog = false;
    }
  },
};
</script>

<style>
@font-face {
  font-family: "Roboto";
  src: local("Roboto"), url(fonts/Rubik/Rubik-Medium.ttf) format("truetype");
}
body {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-weight: 700;
  background-color: #fff;
}
/* This is for documentation purposes and will not be needed in your application */
#app-bar .rss {
  position: absolute;
}
#app-bar .btn-rss--floating {
  position: relative;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(2em);
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.bm-menu {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1000; /* Stay on top */
  top: 0;
  left: 0;
  background-color: rgb(63, 63, 65); /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
}
#buscar86 {
  position: absolute;
  top: 86px;
  right: 10px;
  width: 280px;
  height: 50px;
}
#buscar100 {
  position: absolute;
  top: 100px;
  right: 10px;
  width: 280px;
  height: 50px;
}
.primary .v-icon {
  color: #ffff;
  font-size: 28px;
 
}

/* Oculta la barra de desplazamiento para todo el contenido de la app */
.hide-scroll {
  overflow: hidden;
}

/* Oculta la barra de desplazamiento solo para navegadores WebKit */
.hide-scroll ::-webkit-scrollbar {
  display: none;
}

/* Asegúrate de que el drawer pueda desplazarse */
.drawer-content {
  overflow-y: auto;
}
</style>
